import { DIMENSION_LABELS, type DimensionCode } from '@cessi/shared';

/** Partición visual para etiquetas del radar (dos líneas). */
export function etiquetaDimensionLineas(
  code: Exclude<DimensionCode, 'IN'>,
): [string, string] {
  const nombre = DIMENSION_LABELS[code];
  const idx = nombre.lastIndexOf(' y ');
  if (idx > 0) {
    return [nombre.slice(0, idx + 2).trimEnd(), nombre.slice(idx + 3).trim()];
  }
  const mitad = Math.ceil(nombre.length / 2);
  return [nombre.slice(0, mitad).trim(), nombre.slice(mitad).trim()];
}

export function etiquetaPregunta(code: string): string {
  const m = /^(EV|PC|OD|DC|GS|IN)(\d)$/.exec(code);
  if (!m) return code;
  const dim = m[1] as DimensionCode;
  return `${DIMENSION_LABELS[dim]} · ítem ${m[2]}`;
}
